export default __webpack_public_path__ + "static/media/icon-5.8810d736.png";